import { Breakpoint } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CommonTheme } from '@shared/theme';

const useViewportMatch = (
  // xs and xl don't make sense in any matching
  breakpoint: Exclude<Breakpoint, 'xs' | 'xl'>,
  matchType: 'up' | 'down' = 'up',
) => {
  return useMediaQuery((theme: CommonTheme) => theme.breakpoints[matchType](breakpoint), {
    noSsr: true,
  });
};

export default useViewportMatch;
